import React from 'react';
import PropTypes from 'prop-types';
import { compose, pure, withHandlers } from 'recompose';
import { connect } from 'react-redux';
import { Form as FinalForm } from 'react-final-form';
import createFocusDecorator from 'final-form-focus';
import { withRouter } from 'react-router-dom';

import { getTargetTypeByDocumentCategoryId } from 'selectors';

import { throwSubmissionError } from 'utils';

import Form from './Form';

const propTypes = {
  categoryId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
  match: PropTypes.objectOf(PropTypes.any).isRequired,
  metadata: PropTypes.objectOf(PropTypes.any),
  onSubmit: PropTypes.func.isRequired,
  targetId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  targetType: PropTypes.string.isRequired,
};

const defaultProps = {
  metadata: undefined,
  targetId: undefined,
};

const focusOnError = createFocusDecorator();

function DocumentsUploadForm({ categoryId, match, metadata, onSubmit, targetId, targetType }) {
  const { token } = match.params;
  const initialValues = {
    document: {
      categoryId,
      targetId,
      targetType,
    },
    token,
  };

  return (
    <FinalForm
      initialValues={initialValues}
      onSubmit={onSubmit}
      subscription={{ submitting: true, pristine: true }}
      decorators={[focusOnError]}
      render={(p) => <Form {...p} metadata={metadata} />}
    />
  );
}

DocumentsUploadForm.propTypes = propTypes;
DocumentsUploadForm.defaultProps = defaultProps;

function mapStateToProps(state, { categoryId }) {
  const targetType = getTargetTypeByDocumentCategoryId(state, categoryId);

  return {
    targetType,
  };
}

const enhance = compose(
  withRouter,
  connect(mapStateToProps),
  withHandlers({
    onSubmit: ({ action, handleTogglePanel }) => (values) =>
      action(values)
        .then(() => handleTogglePanel())
        .catch((response) => throwSubmissionError(response)),
  }),
  pure,
);

export default enhance(DocumentsUploadForm);
